import { createGlobalStyle } from 'styled-components';
import tw, { css, theme } from 'twin.macro';

const inputBaseStyles = css`
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill:focus {
    -webkit-text-fill-color: ${theme`colors.text-and-icon`};
    background-color: transparent;
  }

  input:-webkit-autofill,
  textarea:-webkit-autofill,
  select:-webkit-autofill,
  input:-webkit-autofill:hover,
  textarea:-webkit-autofill:hover,
  select:-webkit-autofill:hover {
    -webkit-text-fill-color: ${theme`colors.text-and-icon`};
    background-color: transparent;
  }
`;

const InsightsStyle = createGlobalStyle(
  {
    body: tw`bg-page-background`,
    h3: tw`text-base text-text-and-icon font-semibold text-center`,
    p: tw`text-xs text-text-and-icon-muted text-center`,
    a: tw`text-accent-2 underline`,
    input: tw`autofill:shadow-[0 0 0px 1000px var(--neutral-background) inset] aria-selected:shadow-[0 0 0px 1000px var(--neutral-background) inset] peer-autofill:shadow-[0 0 0px 1000px var(--neutral-background) inset]`,
  },
  inputBaseStyles
);

export default InsightsStyle;
